import OrganizationSchema from './OrganizationSchema';
import ServiceSchema from './ServiceSchema';
import LocalBusinessSchema from './LocalBusinessSchema';
import FAQSchema from './FAQSchema';

// Wrapper component for lazy loading all schema components
const SchemaComponents = ({ socialLinks = [], faqs = [] }) => {
  return (
    <>
      <OrganizationSchema socialLinks={socialLinks} />
      <ServiceSchema />
      <FAQSchema faqs={faqs} />
    </>
  );
};

export {
  OrganizationSchema,
  ServiceSchema,
  LocalBusinessSchema,
  FAQSchema,
  SchemaComponents
};

export default SchemaComponents;